window.addEventListener('DOMContentLoaded', () => {
  const headerBar = document.querySelector('[data-header="js-header"]');
  if (headerBar) {
    const headerHeight = headerBar.clientHeight;
    document.body.style.paddingTop = `${headerHeight}px`;
  }
});
